
import "../../../Foundation/stylable/spacing.st.css.js";
import "../../../Foundation/stylable/easing.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_76_1_LayoutBlocksFooter";
var _style_ = /*#__PURE__*/ classesRuntime.bind(null, _namespace_);

export var cssStates = /*#__PURE__*/ statesRuntime.bind(null, _namespace_);
export var style = /*#__PURE__*/ _style_;
export var st = /*#__PURE__*/ _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_76_1_LayoutBlocksFooter__root","innerContent":"wds_1_76_1_LayoutBlocksFooter__innerContent","divider":"wds_1_76_1_LayoutBlocksFooter__divider","actions":"wds_1_76_1_LayoutBlocksFooter__actions","sideActions":"wds_1_76_1_LayoutBlocksFooter__sideActions"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




